import React, { useReducer } from 'react';
import { GlobalModalContext, reducer } from './GlobalModalContext.js';
import { useModal } from './useModal.js';
/**
 * Keeps track of the modals passed to useModal and renders them.
 */
export function ModalProvider({ children }) {
    const [modals, dispatch] = useReducer(reducer, {});
    return (React.createElement(GlobalModalContext.Provider, { value: { dispatch } },
        children,
        Object.keys(modals).map((key) => (React.createElement(ModalRenderer, { key: key, ...modals[key] })))));
}
function ModalRenderer({ isOpen, props, RenderModal }) {
    const { closeModal } = useModal(RenderModal);
    return React.createElement(RenderModal, { closeModal: closeModal, isOpen: isOpen, ...props });
}
//# sourceMappingURL=ModalProvider.js.map